// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2kmYY","title":"BackImages_title___34mv","images":"BackImages_images__2U0fH"};